/** Rows asked for while the user types — the window opened at the typed text. */
export var PICKER_WINDOW = 50;
/**
 * Rows asked for when a `pickerPreload` picker opens before anything is typed: the top of
 * the register. The controller's maximum, so a closed register of up to that size opens
 * whole, as it did when the picker preloaded it.
 */
export var PICKER_OPEN_WINDOW = 200;
/**
 * The anchor the register is opened at for typed text, or undefined for its top.
 *
 * Lower-cased because the collation (`czna_cs`, ICU) puts lower case first: "praha"
 * sorts before "Praha" and "PRAHA" after it, so an anchor typed in capitals would open
 * the register one row past the heading the user typed.
 */
export var typedAnchor = function (text) {
    var trimmed = text.trim();
    return trimmed ? trimmed.toLocaleLowerCase('cs') : undefined;
};
/** The heading a register row inserts: the record's preferred heading. */
export var insertedHeading = function (entry) { return (entry.headingType === 'VARIANT' && entry.preferredHeadingValue
    ? entry.preferredHeadingValue
    : entry.headingValue); };
/** "→ vloží se {preferred}" — the part of a variant row that names what picking it stores. */
export var insertsSuffix = function (preferred, intl) { return intl.formatMessage({ id: 'ui-czna-authorities.recordPicker.variantInserts' }, { preferred: preferred }); };
/**
 * The row as the picker shows it: a preferred heading as it is, a variant as
 * "{variant} → vloží se {preferred}", so it is plain that picking it stores the other one.
 */
export var registerRowLabel = function (entry, intl) {
    var inserted = insertedHeading(entry);
    if (inserted === entry.headingValue) {
        return entry.headingValue;
    }
    return "".concat(entry.headingValue, " ").concat(insertsSuffix(inserted, intl));
};
/**
 * One row per record, at its first position in the window. A record whose preferred
 * heading and a variant both fall into the window would otherwise be offered twice, and a
 * picker's options are keyed by the record id it stores.
 */
export var firstRowPerRecord = function (entries) {
    var seen = new Set();
    return entries.filter(function (entry) {
        if (seen.has(entry.recordId))
            return false;
        seen.add(entry.recordId);
        return true;
    });
};
